/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_CustomerService_Dtos_TermsAndConditions_TermsAndConditionsBlobDto } from '../models/Wealthlane_CustomerService_Dtos_TermsAndConditions_TermsAndConditionsBlobDto';
import type { Wealthlane_CustomerService_Dtos_TermsAndConditions_TermsAndConditionsListDto } from '../models/Wealthlane_CustomerService_Dtos_TermsAndConditions_TermsAndConditionsListDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class VendorTermsAndConditionsSharedService {

    /**
     * @returns Wealthlane_CustomerService_Dtos_TermsAndConditions_TermsAndConditionsListDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiVendorTermsAndConditionsBrokerageOnboarding(): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_TermsAndConditions_TermsAndConditionsListDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/vendor-terms-and-conditions/brokerage-onboarding',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param token
     * @returns Wealthlane_CustomerService_Dtos_TermsAndConditions_TermsAndConditionsListDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiVendorTermsAndConditionsParticipantOnboarding(
        token?: string,
    ): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_TermsAndConditions_TermsAndConditionsListDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/vendor-terms-and-conditions/participant-onboarding',
            query: {
                'token': token,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param termsAndConditionId
     * @returns Wealthlane_CustomerService_Dtos_TermsAndConditions_TermsAndConditionsBlobDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiVendorTermsAndConditionsDownload(
        termsAndConditionId: string,
    ): CancelablePromise<Wealthlane_CustomerService_Dtos_TermsAndConditions_TermsAndConditionsBlobDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/vendor-terms-and-conditions/download/{termsAndConditionId}',
            path: {
                'termsAndConditionId': termsAndConditionId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
